import i18n from '../i18n';
import { categories } from './categories';

export const getMacroName = (macroId) => {
  const key = `categories.macro_${macroId}`;
  const translated = i18n.t(key);
  if (translated !== key) return translated;

  const macro = categories.find((cat) => cat.id === macroId);
  return macro ? macro.macro : i18n.t('categories.unknown_category');
};

export const getMicroName = (microId) => {
  const key = `categories.micro_${microId}`;
  const translated = i18n.t(key);
  if (translated !== key) return translated;

  for (const category of categories) {
    const micro = category.micro.find((m) => m.id === microId);
    if (micro) return micro.name;
  }
  return i18n.t('categories.unknown_subcategory');
};

export const getMatchingCategoryIds = (query) => {
  const lowerQuery = query.toLowerCase();

  const matchingMacroIds = categories
    .filter((c) => getMacroName(c.id).toLowerCase().includes(lowerQuery))
    .map((c) => c.id);

  const matchingMicroIds = categories
    .flatMap((c) => c.micro)
    .filter((m) => getMicroName(m.id).toLowerCase().includes(lowerQuery))
    .map((m) => m.id);

  return {
    macroCategories: matchingMacroIds,
    microCategories: matchingMicroIds,
  };
};
